export const RECENT_CACHE_STORE_KEY = {
  CREATOR: 'recent_creators',
  PRODUCT: 'recent_products',
} as const;

export const RECENT_CACHE_STORE_CREATOR_OPTION = {
  limit: 60,
  expired: 7 * 24 * 60 * 60 * 1000,
} as const;

export const RECENT_CACHE_STORE_PRODUCT_OPTION = {
  limit: 100,
  expired: 7 * 24 * 60 * 60 * 1000,
} as const;

export type RecentCacheStoreKey = (typeof RECENT_CACHE_STORE_KEY)[keyof typeof RECENT_CACHE_STORE_KEY];
